import React, { useState, useEffect } from "react";
import { ClockSvg } from "../../assets/svg";
import { Separator } from "../separator";
import GatherTableContent from "./gather-consent-table-content";
import { useAppSelector } from "../../redux/hook";
import { ConsentApplication, OwnerConsentStatus } from "../../models/polymer/ConsentApplication.model";
import useIsMobile from "../../hooks/use-is-mobile";
import { PolymerCrypto } from "../../utils/encryptor";
import { P2TextLabel } from "react-bootstrap-common-script";
import useGetEligibilityOverride from "../../hooks/use-get-eligibility-override";
import { EligibilityCheck } from "../../models/classes/EligibilityOverride.class";
interface GatherConsentTableProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  applicationSubmitted?: string;
  timeRemaining?: string;
  setConsentComplete?: (value: boolean) => void;
  consentApplication?: ConsentApplication
}

const GatherConsentTable = ({ applicationSubmitted, timeRemaining, setConsentComplete, consentApplication }: GatherConsentTableProps) => {
  const [consentedOwners, setConsentedOwners] = useState<OwnerConsentStatus[]>([]);
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const { isMobile } = useIsMobile();
  const { consentBypassNrics } = useGetEligibilityOverride(applicationStartFormData.selected_hdb_property?.hdb_ref);
  
  useEffect(() => {
    if (!consentApplication) return;

    setConsentedOwners(consentApplication.owners_consent_status);
    if (setConsentComplete) {
      let consentComplete = true;
      if (
        consentApplication.owners_consent_status.length > 0 &&
        consentApplication.owners_consent_status
          .filter((e) => e.consent_check !== EligibilityCheck.EXEMPT)
          .filter((e) => !consentBypassNrics.includes(PolymerCrypto.decryption(e.uin_fin)))
          .find((item: OwnerConsentStatus) => item.consent_given === false)
      ) {
        consentComplete = false;
      }
      setConsentComplete(consentComplete);
    }
  }, []);

  return (
    <div className="polymer-gather-table-main-container">
      <div className="polymer-gather-table-sub-container">
        <p className="polymer-gather-table-submitted-text">{applicationSubmitted}</p>
        {!isMobile &&  <div className="polymer-gather-table-clock-time-remaining">
          <ClockSvg />
          <p className="polymer-gather-table-time-remaining">{timeRemaining}</p>
        </div>}
        <P2TextLabel label={<div>What do remaining owners need to do?</div>} marginBottom="1rem"/>
        <P2TextLabel bold={400} fontSize={"1.125rem"} label={<div><span style={{fontWeight: 700}}>1. </span>Log in to the “Manage Application for Change in Flat Ownership” e-Service using their own Singpass account.</div>}/>
        <P2TextLabel bold={400} fontSize={"1.125rem"} label={<div><span style={{fontWeight: 700}}>2. </span>After logging in, click on the alert banner at the top of the dashboard that requests for them to give consent for the submitted application.</div>}/>
        <P2TextLabel bold={400} fontSize={"1.125rem"} label={<div><span style={{fontWeight: 700}}>3. </span>Review the application to give your consent.</div>} marginBottom="1rem"/>
     
        <Separator />
        <div className="polymer-gather-table-main">
          <GatherTableContent children={consentedOwners} uinfinsToBypass={consentBypassNrics} />
        </div>
      </div>
    </div>
  );
};

export default GatherConsentTable;
